import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Priority } from './types/operations.types'
import {
  OpsPageWrapper,
  OpsCard,
  OpsCardHeader,
  FormSection,
  FormLabel,
  FormInput,
  FormTextarea,
  FormSelect,
  RadioGroup,
  RadioCard,
  InfoBox,
  OpsButton,
  opsColors,
} from './styled/Operations.styled'

const PRIORITIES: Priority[] = ['Critical', 'High', 'Medium', 'Low']

export const CreateManualTask: React.FC = () => {
  const navigate = useNavigate()
  const [taskName, setTaskName] = useState('')
  const [departmentId, setDepartmentId] = useState('')
  const [locationId, setLocationId] = useState('')
  const [priority, setPriority] = useState<Priority>('Medium')
  const [assigneeId, setAssigneeId] = useState('')
  const [notes, setNotes] = useState('')

  const handleCreate = () => {
    if (!taskName) {
      toast.error('Task name is required')
      return
    }
    // Mock creation
    toast.success('Manual task created')
    navigate(-1)
  }

  return (
    <OpsPageWrapper>
      <h1 style={{ fontSize: '30px', fontWeight: 900, color: opsColors.textPrimary, margin: 0, fontFamily: 'DM Sans, sans-serif' }}>
        Create Manual Task
      </h1>

      <OpsCard>
        <FormSection>
          <OpsCardHeader><h3>Task Details</h3></OpsCardHeader>

          <div>
            <FormLabel>Task Name *</FormLabel>
            <FormInput value={taskName} onChange={(e) => setTaskName(e.target.value)} placeholder="Describe the task..." />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div>
              <FormLabel>Department</FormLabel>
              <FormSelect value={departmentId} onChange={(e) => setDepartmentId(e.target.value)}>
                <option value="">Select department...</option>
                <option value="4">Maintenance</option>
                <option value="5">Camp Services</option>
                <option value="6">Security</option>
                <option value="1">Operations</option>
              </FormSelect>
            </div>
            <div>
              <FormLabel>Location</FormLabel>
              <FormSelect value={locationId} onChange={(e) => setLocationId(e.target.value)}>
                <option value="">Select location...</option>
                <option value="1">Pit B</option>
                <option value="2">Crusher Area</option>
                <option value="3">Workshop A</option>
                <option value="4">Main Gate</option>
              </FormSelect>
            </div>
          </div>

          <div>
            <FormLabel>Priority</FormLabel>
            <RadioGroup>
              {PRIORITIES.map((p) => (
                <RadioCard key={p} active={priority === p} onClick={() => setPriority(p)}>{p}</RadioCard>
              ))}
            </RadioGroup>
          </div>

          <div>
            <FormLabel>Assign To (optional)</FormLabel>
            <FormSelect value={assigneeId} onChange={(e) => setAssigneeId(e.target.value)}>
              <option value="">Unassigned</option>
              <option value="1">Peter M.</option>
              <option value="2">Michael K.</option>
              <option value="3">Robert G.</option>
              <option value="4">Anna V.</option>
            </FormSelect>
          </div>

          <div>
            <FormLabel>Notes</FormLabel>
            <FormTextarea value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Additional instructions..." />
          </div>

          <InfoBox variant="info">
            This task will be created with source: MANUAL. It has no shift boundary and persists until completed.
          </InfoBox>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0.5rem' }}>
            <OpsButton variant="secondary" onClick={() => navigate(-1)}>Cancel</OpsButton>
            <OpsButton onClick={handleCreate}>Create Task</OpsButton>
          </div>
        </FormSection>
      </OpsCard>
    </OpsPageWrapper>
  )
}
